import React, { Component } from 'react';
import { BASE } from '../api/api'
import Axios from 'axios'
import cachios from 'cachios'
import { Link } from 'react-router-dom'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import SideBar from '../sidebar/sidebar'
import { List } from 'react-content-loader'
import './gloss.css'
import search from '../assets/search.png'


class Glossary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      news: '',
      glossary: '',
      search: props.match.params.key ? props.match.params.key : '', inputhide: false,
      next: false,
      prev: false,
      limit: 15,
      offset: new URL(window.location.href).searchParams.get("start") ? 15 : 0,
      loginpopup: false
    }
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  signout(id) {
    localStorage.removeItem('token');
    localStorage.removeItem('expirytime');
    localStorage.removeItem('expiryref');
    if (id)
      this.props.history.push('/login?redir=/glossary?start=2')
    else
      this.props.history.push('/login?redir=/glossary')
  }




  refreshexp() {
    let s = new Date();
    s.setSeconds(s.getSeconds() + 1800);
    localStorage.setItem('expiryref', s)
  }


  checkexpiry(id) {
    if (localStorage.getItem('expiryref')) {
      let expref = Date.parse(localStorage.getItem('expiryref'))
      let s = new Date();
      if (s > expref) {
        this.fillalert('Session Expired!Logging Out')
        this.signout(id)
      }
      else {
        this.refreshexp()
      }

    }
    else {
      this.fillalert('Session Expired!Logging Out')
      this.signout(id)

    }
  }

  // componentWillMount(){
  //   if(this.state.token)
  //       this.checkexpiry()
  // }


  handlePageClick = data => {
    if (!this.logincheck()) {
      this.gotologin('next')
    }
    else
      this.checkexpiry('next')

    if (data === 'next' && this.state.next === true) {

      this.setState({
        glossary: '',
      })
      this.apicall(this.state.offset + this.state.limit, this.state.search)
      this.setState({
        offset: this.state.offset + this.state.limit
      })
    }

    else if (data === 'prev' && this.state.prev === true) {
      this.setState({
        glossary: '',
      })
      this.setState({
        offset: this.state.offset - this.state.limit
      })
      this.apicall(this.state.offset - this.state.limit, this.state.search)
    }
  }


  componentWillMount() {
    this.apicall(this.state.offset, this.state.search)
  }

  // componentWillReceiveProps(nextProps){
  //     if(nextProps.match.params.key)
  //     {this.setState({
  //         glossary:'',
  //         search:nextProps.match.params.key
  //     })
  //     this.apicall(0,nextProps.match.params.key)}
  //     else{
  //     this.setState({
  //             offset:0,
  //             search:''
  //           })
  //     }

  // }

  redirnext() {
    let login = localStorage.getItem('token');
    if (login && login != null) {
      return true
    }
    else {
      this.props.history.push('/login?redir=/glossary?start=2')
    }
  }
  apicall(id, contains) {
    if (id !== 0) {
      this.redirnext()
    }
    if (contains) {
      let login = localStorage.getItem('token');
      if (!login || login === null) {
        this.props.history.push('/login?redir=/glossary/' + contains)

      }
    }
    localStorage.removeItem('pagenum')
    this.setState({
      glossary: ''
    })
    this.topFunction();
    if (id <= 0) {
      this.setState({
        prev: false,
      })
    }
    else {
      this.setState({
        prev: true
      })
    }

    //to check Next page
    Axios(BASE + 'jsonapi/node/glossary?filter[title][condition][path]=title&filter[title][condition][operator]=CONTAINS&filter[title][condition][value]=' + contains.replace(/^\s+/g, '') + '&page[limit]=' + this.state.limit + '&page[offset]=' + (id + this.state.limit), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
      .then((data) => {
        console.log(data.data, 'next')
        //HIDE/SHOW  NEXT button
        if (data.data.data.length === 0) {
          this.setState({
            next: false,
          })
        }
        else {
          this.setState({
            next: true
          })
        }
      })


    cachios.get(BASE + 'jsonapi/node/glossary?filter[title][condition][path]=title&filter[title][condition][operator]=CONTAINS&filter[title][condition][value]=' + contains.replace(/^\s+/g, '') + '&page[limit]=' + this.state.limit + '&page[offset]=' + id, {
      ttl: 500 /* seconds */,
    })
      .then((data) => {
        if (localStorage.getItem('token'))
          this.checkexpiry()
        console.log(data.data.data, 'url')
        if (data.data.data.length === 0) {


          this.fillalert()
          // this.setState({
          //   people: []
          // })
          this.setState({
            offset: 0,
            // search: '',
            glossary: []
          })
        }
        this.setState({
          glossary: data.data.data,
          temp_glossary: data.data.data
        })
      })
      .catch((err) => {
        console.log('not found')
      })

  }

  getHighlightedText(text) {
    // Split on higlight term and include term into parts, ignore case
    if (this.state.search) {
      let parts = text.split(new RegExp(`(${this.state.search})`, 'gi'));
      return <div className="myspan"> {parts.map((part, i) =>
        <span key={i} style={part.toLowerCase() === this.state.search.toLowerCase() ? { backgroundColor: 'yellow', display: 'inline' } : {}}>
          {part}
        </span>)
      } </div>;
    }
    else {
      return (text)
    }
  }

  submit() {
    let login = localStorage.getItem('token');
    if (login && login != null) {
      this.apicall(0, this.state.search)
      this.setState({
        offset: 0
      })
    }
    else {
      this.props.history.push('/login?redir=/glossary/' + this.state.search)
    }

  }

  _handleKeyPress(e) {

    if (e.key === 'Enter') {

      this.submit()

    }
  }


  handlechange(id, keyword) {
    if (this.logincheck()) {
      this.checkexpiry()
      this.setState({
        search: keyword
      })
      if (keyword === '') {
        this.apicall(0, '')
      }
    }
    else
      this.gotologin()

  }

  gotologin(id) {
    if (id)
      this.props.history.push('/login?redir=/glossary?start=2')
    else
      this.props.history.push('/login?redir=/glossary')
  }

  logincheck() {
    let login = localStorage.getItem('token');
    if (login && login != null) {
      return true
    }
    else
      return false
  }

  headerActive(e) {
    this.setState({
      inputhide: e
    })
  }
  fillalert() {
    this.setState({
      fillalert: true
    })
    setTimeout(
      function () {
        this.setState({
          fillalert: null
        })
      }
        .bind(this),
      3000
    );
  }




  render() {



    return (

      <div className='glossary'>
        <div onClick={() => this.setState({ loginpopup: false })} style={{ display: this.state.loginpopup ? '' : 'none' }} className='bgoverlay'></div>
        {this.state.fillalert ?
          <div className="fill-alert">No Results Found for <span id="noword">{this.state.search}</span>
          </div> : ''}

        <Header headerActive={(e) => this.headerActive(e)} />
        <div className='container side-arrange'>
          <SideBar data={'data3'} />
          <div className='listings'>
            <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/glossary'>Glossary of Terms</Link></div>
            <div className="page-title">
              <div className="title-wrapper">
                <div className="gloss_container">
                  <h1 className=" heading">Glossary of Terms</h1>
                  <div className="search_input" style={{ alignSelf: 'center', zIndex: this.state.inputhide == true ? -1 : 0 }}>
                    <input type="text" placeholder="Search" value={this.state.search} name="search" onChange={(e) => { this.handlechange(0, e.target.value) }} onKeyPress={(e) => this._handleKeyPress(e)} maxLength={50} />
                    <div className="search_logo">
                      <img onClick={() => this.submit()} src={search} height="20px" />
                    </div>                                {/* </form> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="main-content listing">
              <div className=" newsrea">
                <div className="row">
                  <div className="region region-content">
                    <div className="listings">
                      <span className="field-content head">
                        <div className='term'>Terms</div>
                        <div className='defn'>Definition</div>

                      </span>
                      {this.state.glossary ?
                        this.state.glossary.length != 0 ?
                          this.state.glossary.map((glossary, index) => {
                            return (
                              <div className="title terms">
                                <span className="field-content">
                                  <div className='term mobhead'>Terms</div>

                                  <div className='term termmob'>{this.getHighlightedText(glossary.attributes.title)}</div>
                                  <div className='defn mobhead cont'>Definition</div>

                                  <div className='defn defnmob cont'>{glossary.attributes.body.value}</div>

                                </span>
                              </div>
                            )
                          }) : <div className="noalert">No Matching Records Found for <span id="noword">{this.state.search}</span> </div> : <List />

                      }

                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.state.glossary && (this.state.prev || this.state.next) ?

              <ul className="pagination">
                <li onClick={() => this.handlePageClick('prev')} className="previous disabled">
                  <a style={{ color: this.state.prev ? '#165E84' : '', fontWeight: this.state.prev ? '500' : '', cursor: this.state.prev ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
                <li onClick={() => this.handlePageClick('next')} className="next"><a style={{ color: this.state.next ? '#165E84' : '', fontWeight: this.state.next ? '500' : '', cursor: this.state.next ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>

              </ul>

              : ''}
          </div>
        </div>
        <div><Footer /></div>
      </div>
    )


  }

}


export default Glossary;
